// engineeringPhysicsData.js

const engineeringPhysicsData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "24",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34", code: "MATH 34", title: "Calculus II", credit: 4 },
        { id: "MATH42", code: "MATH 42", title: "Calculus III", credit: 4 },
        { id: "MATH51", code: "MATH 51", title: "Differential Equations", credit: 4 },
        { id: "ProbStat_a", code: "Probability & Statistics (a)", title: "", credit: "3-4" },
        {
          id: "CHEM1_11_16",
          code: "CHEM 1 / CHEM 11 / CHEM 16",
          title:
            "Gen. Chem. I w/ lab or Exp. Gen. Chem. I w/ lab or Chem. of Materials",
          credit: "5-6",
        },
      ],
    },
    {
      section: "Physics",
      subtotal: "34",
      courses: [
        { id: "PHY11", code: "PHY 11", title: "Gen. Physics I w/ lab", credit: 5 },
        { id: "PHY12", code: "PHY 12", title: "Gen. Physics II w/ lab", credit: 5 },
        { id: "PHY13", code: "PHY 13", title: "Intro. Modern Physics", credit: 4 },
        { id: "PHY32", code: "PHY 32", title: "Intermediate Mechanics", credit: 4 },
        { id: "PHY52", code: "PHY 52", title: "Thermal Physics", credit: 3 },
        { id: "PHY64", code: "PHY 64", title: "Adv. Experimental Physics", credit: 4 },
        {
          id: "PhysAstr_Elec_b1",
          code: "Physics & Astronomy Elective (b)",
          title: "",
          credit: "≥3",
        },
        {
          id: "PhysAstr_Elec_b2",
          code: "Physics & Astronomy Elective (b)",
          title: "",
          credit: "≥3",
        },
        {
          id: "PhysAstr_Elec_b3",
          code: "Physics & Astronomy Elective (b)",
          title: "",
          credit: "≥3",
        },
      ],
    },
    {
      section: "HASS",
      subtotal: "24",
      courses: [
        { id: "ENG1", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        {
          id: "Humanities_Elec_c",
          code: "Humanities Elective (c)",
          title: "",
          credit: "≥3",
        },
        {
          id: "SocialSci_Elec_d",
          code: "Social Science Elective (d)",
          title: "",
          credit: "≥3",
        },
      ],
    },
    {
      section: "Engineering & Computing",
      subtotal: "30",
      courses: [
        { id: "EN1_EP", code: "EN 1", title: "Applications in Eng.", credit: 3 },
        {
          id: "ES2_CS11_EP",
          code: "ES 2 or CS 11",
          title: "Intro. Comp. in Eng. or Intro. Comp. Sci.",
          credit: 4,
        },
        { id: "Disc_Elec_f1", code: "Discipline Elective (f)", title: "", credit: "≥3" },
        { id: "Disc_Elec_f2", code: "Discipline Elective (f)", title: "", credit: "≥3" },
        { id: "Disc_Elec_f3", code: "Discipline Elective (f)", title: "", credit: "≥3" },
        { id: "Disc_Elec_f4", code: "Discipline Elective (f)", title: "", credit: "≥3" },
        { id: "GenEng_Elec_g1", code: "General Eng elective (g)", title: "", credit: "≥3" },
        { id: "GenEng_Elec_g2", code: "General Eng elective (g)", title: "", credit: "≥3" },
        { id: "AddGenEng_Elec_g1", code: "General Eng elective (g)", title: "", credit: "≥3" },
        { id: "AddGenEng_Elec_g2", code: "General Eng elective (g)", title: "", credit: "≥3" },
      ],
    },
    {
      section: "Technical Electives",
      subtotal: "10",
      courses: [
        { id: "Tech_Elec_h1", code: "Technical Elective (h)", title: "", credit: "≥2" },
        { id: "Tech_Elec_h2", code: "Technical Elective (h)", title: "", credit: "≥2" },
        { id: "Tech_Elec_i1", code: "Technical Elective (i)", title: "", credit: "≥2" },
        { id: "Tech_Elec_i2", code: "Technical Elective (i)", title: "", credit: "≥2" },
        { id: "Tech_Elec_i3", code: "Technical Elective (i)", title: "", credit: "≥2" },
      ],
    },
  ];
  
  export default engineeringPhysicsData;
  